import { useEffect, useState } from 'react';
import TController from './components/view/TController';
import { IData } from './helpers/interface';
import lodash from 'lodash';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Box from '@mui/material/Box/Box';
import ChildHeader from '../../components/ui/ChildHeader';
import {
  SaveButton,
  SubmitButton,
} from '../../components/common/button/CustomButtons';
import { useAuth } from '../../services/auth/AuthProvider';
import { useQuery } from '../../hooks/UseQuery';
import {
  initialStateMechanical,
  initialStatePnumetic,
} from './helpers/initialState';

import useConfirm from '../../components/common/useConfirm';

const View = () => {
  const document_type = useQuery('document_type') || '';
  const initialState: any = {
    mechanical: initialStateMechanical,
    pnumetic: initialStatePnumetic,
  };
  const [moduleData, setModuleData] = useState<IData>(
    lodash.cloneDeep(initialState[document_type])
  );
  const navigate = useNavigate();
  const { state } = useAuth();
  const { id } = useParams();
  const annual_month = useQuery('annual_date') || '';
  const isView = useQuery('isView') === 'true' ? true : false;

  const [machineData, setMachineData] = useState([]);

  const [DialogSubmit, confirmSubmit] = useConfirm(
    'Submit',
    'Are you sure you want to save this document?'
  );

  useEffect(() => {
    if (annual_month) {
      axios
        .get(
          `/api/machineCheckSheetRoute/${annual_month}?document_type=${document_type}`
        )
        .then((res) => {
          setModuleData(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  useEffect(() => {
    axios
      .get('/api/machineRoutes/')
      .then((res) => {
        setMachineData(res.data.results);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleSumbit = async (isSubmitted: boolean) => {
    const ans = await confirmSubmit();
    if (!ans) return;
    moduleData.isSubmitted = isSubmitted;
    moduleData.is_admin_request = 'pending';
    moduleData.report_prepared_by = state.user?.name;
    if (moduleData._id) {
      await axios
        .put(`/api/machineCheckSheetRoute/${moduleData._id}`, moduleData)
        .then((res) => {
          if (res.data.status === 'success') {
            alert('Updated Successfully');
          }
        })
        .catch((err) => console.log(err));
    } else {
      if (!annual_month) {
        return alert('Please pick annual year?');
      }
      moduleData.annual_month = annual_month;
      moduleData.document_type = document_type;
      await axios
        .post('/api/machineCheckSheetRoute', moduleData)
        .then((res) => {
          if (res.data.status === 'success') {
            alert('created Successfully');
            navigate(
              `/common/createMachineCheckSheet?isView=false&document_type=${document_type}`
            );
          }
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <>
      <Box>
        <ChildHeader text={`${document_type.toUpperCase()} CHECK SHEET`}>
          {!isView && (
            <>
              {state.user?.userType === state.IS.Supervisor && (
                <SaveButton
                  label="Save & Continue"
                  onClick={() => handleSumbit(false)}
                />
              )}
              <SubmitButton label="Submit" onClick={() => handleSumbit(true)} />
            </>
          )}
        </ChildHeader>
      </Box>
      <TController
        {...{
          moduleData,
          isView,
          machineData,
        }}
      />

      <DialogSubmit />
    </>
  );
};

export default View;
